@import (reference) '../../../../constants/spacing.module.less';

.filter-bar-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: @space-8 @space-16;
  background-color: var(--default--background-color);
  border-bottom: 1px solid var(--default--header--border-color--3);
}

.filter-bar-actions-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 32px;
  padding: @space-4 0;
}

.filter-action-buttons {
  display: flex;
  justify-content: space-between;
  margin-right: @space-32;
  gap: @space-16;
}

.filter-action-divider {
  border-color: var(--grey-400);
  height: 20px;
}
